import {InputGroup, InputGroupProps, Label} from "@blueprintjs/core";
import React from "react";

type Props = Omit<InputGroupProps, "id"> & {
    id: string;
    label: string;
};

const LableInput = ({id, label, ...props}: Props) => {
    return (
        <Label htmlFor={id}>
            {label}
            <InputGroup id={id} {...props} data-testid="template-list-title-search-input" />
        </Label>
    );
};

export default LableInput;
